/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PromptRatingAggregation } from './PromptRatingAggregation';
import {
    PromptRatingAggregationFromJSON,
    PromptRatingAggregationFromJSONTyped,
    PromptRatingAggregationToJSON,
} from './PromptRatingAggregation';

/**
 * 
 * @export
 * @interface GetPromptRatingAggregationResponseContent
 */
export interface GetPromptRatingAggregationResponseContent {
    /**
     * 
     * @type {Array<PromptRatingAggregation>}
     * @memberof GetPromptRatingAggregationResponseContent
     */
    feedback: Array<PromptRatingAggregation>;
}


/**
 * Check if a given object implements the GetPromptRatingAggregationResponseContent interface.
 */
export function instanceOfGetPromptRatingAggregationResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "feedback" in value;

    return isInstance;
}

export function GetPromptRatingAggregationResponseContentFromJSON(json: any): GetPromptRatingAggregationResponseContent {
    return GetPromptRatingAggregationResponseContentFromJSONTyped(json, false);
}

export function GetPromptRatingAggregationResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPromptRatingAggregationResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'feedback': ((json['feedback'] as Array<any>).map(PromptRatingAggregationFromJSON)),
    };
}

export function GetPromptRatingAggregationResponseContentToJSON(value?: GetPromptRatingAggregationResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'feedback': ((value.feedback as Array<any>).map(PromptRatingAggregationToJSON)),
    };
}

